import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { AnalyticsProvider, Grid, Spinner, IButtonSpanProps, IButtonAnchorProps, TGridColumnWidth } from 'telia-front-react';
import NotFound from '../notfound/NotFound';
import DigitarkNewsStore, { DigitarkNewsItem } from '../stores/DigitarkNewsStore';
import DigitarkNewsCard from './DigitarkNewsCard';
import DigitarkNewsColumn from './DigitarkNewsColumn';
import DigitarkNewsCardB2B from './DigitarkNewsCardB2B';

export interface FeedDigitarkProps {
  tag?: string;
  amount?: number;
  grid?: TGridColumnWidth[];
  dateFormat?: string;
  showButton?: boolean;
  showDate?: boolean;
  button?: IButtonSpanProps | IButtonAnchorProps;
  view?: 'column' | 'b2b';
  digitarkNewsStore?: DigitarkNewsStore;
  video?: boolean;
  gaLabel?: string;
}

@observer
class FeedDigitark extends React.Component<FeedDigitarkProps> {
  public componentDidMount() {
    const { tag, video, view } = this.props;
    this.props.digitarkNewsStore.loadNews(this.getNewsAmount(), tag, video, view === 'b2b');
  }

  private getNewsAmount() {
    if (this.props.amount) {
      return this.props.amount;
    }
    switch (this.props.view) {
      case 'b2b':
        return 3;
      default:
        return 2;
    }
  }

  private renderDigitarkNewsContainer(item: DigitarkNewsItem) {
    const { showButton, button, grid, showDate, dateFormat, view } = this.props;

    switch (view) {
      case 'b2b':
        return <DigitarkNewsCardB2B key={item.id} grid={grid} originalTitle={item.originalTitle} {...item} />;
      case 'column':
        return <DigitarkNewsColumn key={item.id} id={item.id} date={dateFormat} originalTitle={item.originalTitle} {...item} grid={grid} />;
      default:
        return (
          <DigitarkNewsCard
            key={item.id}
            showButton={showButton}
            showDate={showDate}
            button={button as IButtonSpanProps}
            dateFormat={dateFormat}
            grid={grid}
            {...item}
          />
        );
    }
  }

  public render() {
    const { digitarkNewsStore, tag, view, video } = this.props;
    const teliaFeaturedHome = view === 'b2b';

    if (digitarkNewsStore.isFetching(tag, video, teliaFeaturedHome)) {
      return <Spinner />;
    } else if (digitarkNewsStore.notFound(tag)) {
      return <NotFound />;
    }
    const newsItems = digitarkNewsStore.getNewsItems(this.getNewsAmount(), tag, video, teliaFeaturedHome);

    return (
      <AnalyticsProvider group={'Digitark'}>
        <Grid verticalGutter={teliaFeaturedHome ? 'medium' : 'default'} element="ul">
          {newsItems.map((item) => this.renderDigitarkNewsContainer(item))}
        </Grid>
      </AnalyticsProvider>
    );
  }
}

export default inject('digitarkNewsStore')(FeedDigitark);
